import React from 'react';
import { Button, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { setSelectedOption } from '../../../redux/actions/philipsITAction';
import { setPhilipsITFeedback } from '../../../redux/actions/feedbackActions';

const { Title } = Typography;

const translations = {
    English: {
      chooseFeedback: "Choose what you like to share feedback on?",
    },
    Japanese: {
      chooseFeedback: "フィードバックを共有したい内容を選んでください。",
    },
    Chinese: {
      chooseFeedback: "请选择您想提供反馈的内容？",
    },
    Dutch: {
      chooseFeedback: "Kies waarover u feedback wilt geven.",
    },
    German: {
      chooseFeedback: "Wählen Sie aus, worüber Sie Feedback geben möchten.",
    },
    Spanish: {
      chooseFeedback: "Elija sobre qué le gustaría dar su opinión.",
    },
    French: {
      chooseFeedback: "Choisissez sur quoi vous souhaitez donner votre avis.",
    }
  };

  
const FeedbackComponent = () => {
    const dispatch = useDispatch();

    const selectedOption = useSelector((state) => state.philipsIT.selectedOption);
    const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
    const translation = translations[selectedLanguage]; 
    const [hovered, setHovered] = useState(null);
    const options = [
        'AWS Servers',
        'Azure Servers',
        'GCP Servers',
        'On-Prem Servers',
        'Foundational Service',
        'Others'
    ];   

    const handleOptionClick = (option) => {
      dispatch(setSelectedOption(option));    
      dispatch(
        setPhilipsITFeedback(
          option, 
          translations['English'].chooseFeedback 
        )
      );
    };
    const getOptionButtonStyle = (option) => {
      const isSelected = selectedOption === option;
      const isHovered = hovered === option;
    
      return {
        width: "170px",
        fontSize: "13px",
        justifyContent: "space-between",
        margin: "15px",
        fontWeight: "500",
        color: "black",
        backgroundColor: isSelected
          ? "#E0EBF1"
          : isHovered
          ? "#D1DDEA"
          : "white",
          
        border: isSelected || isHovered
          ? "2px solid #CAD2D8"
          : "2px solid  #CAD2D8",
        transition: "all 0.3s ease",
      };
    };

    return (
        <div style={{ padding: '20px' }}>
            <Title style={{ marginLeft: "14px", fontWeight: "bolder" }} level={3}>
                {translation.chooseFeedback}
            </Title>
            <div>
                {options.map((option) => (
                    // <Button
                    //     key={option}
                    //     type={selectedOption === option ? "primary" : "default"}
                    //     style={{ width: "170px", fontSize:"13px", justifyContent: 'space-between', margin: '15px', color:"black", fontWeight:"500", backgroundColor:"white", border:selectedOption === option ? "2px solid #1677ff": "1px solid gray"}}
                    //     onClick={() => handleOptionClick(option)}
                    // >
                    //     {option}
                    // </Button>

<Button
  key={option}
  type={selectedOption === option ? "primary" : "default"}
  style={getOptionButtonStyle(option)}
  onClick={() => handleOptionClick(option)}
  onMouseEnter={() => setHovered(option)}
  onMouseLeave={() => setHovered(null)}
>
  {option}
</Button>

                ))}
            </div>
        </div>
    );
};

export default FeedbackComponent;
